import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective } from '_components';
import styles from './Common.module.css'

class ROMComments extends React.Component {

    render() {
        return (
            <div className={styles.textarea_row}>
                <span className={styles.flag} />
                <label className={styles.textarea_label}>Comments</label>
                <DBTextAreaObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROCOMMENTS'
                    className={styles.textarea}
                />
                <span className={styles.prev_comments_wrapper}>
                    {this.props.prevComments}
                </span>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));

    let prevComments = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVEROMPREV[pk]) {
        prevComments = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROCOMMENTS'];
    }


    return {
        noteId,
        rono,
        prevComments,
    };
}

const connectedROMComments = connect(mapStateToProps)(ROMComments);
export { connectedROMComments as ROMComments };


